import React from 'react';

interface TagFilterProps {
  tags: string[];
  activeTags: string[];
  onChange: (tags: string[]) => void;
}

const TagFilter: React.FC<TagFilterProps> = ({ tags, activeTags, onChange }) => {
  const toggleTag = (tag: string) => {
    if (activeTags.includes(tag)) {
      onChange(activeTags.filter((t) => t !== tag));
    } else {
      onChange([...activeTags, tag]);
    }
  };

  if (tags.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 overflow-x-auto py-1" dir="rtl">
      <span className="text-xs font-semibold text-gray-500 font-heebo">מסננים:</span>
      <div className="flex gap-1.5">
        {tags.map((tag) => {
          const isActive = activeTags.includes(tag);
          return (
            <button
              key={tag}
              onClick={() => toggleTag(tag)}
              className={`px-2 py-1 text-xs font-heebo border border-solid transition-colors duration-150 rounded-none ${
                isActive
                  ? 'bg-black text-white border-black'
                  : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
              }`}
            >
              {tag}
            </button>
          );
        })}
      </div>
      {activeTags.length > 0 && (
        <button
          onClick={() => onChange([])}
          className="px-2 py-1 text-xs font-heebo border border-dashed border-gray-400 text-gray-600 hover:bg-gray-50 rounded-none"
        >
          נקה הכל
        </button>
      )}
    </div>
  );
};

export default TagFilter;